export default ({ to, from, next }) => {
  const userToken = localStorage.getItem('userToken')
  const condoUserId = localStorage.getItem('condoUserId')
  const condoOrganizationId = localStorage.getItem('condoOrganizationId')
  const currentOrganizationId = localStorage.getItem('currentOrganizationId')

  if (!userToken) {
    console.log('No userToken found, redirecting to root')
    next('/')
    return false
  }

  if (!condoUserId || !condoOrganizationId || !currentOrganizationId) {
    console.log('Missing required parameters, redirecting to root')
    next('/')
    return false
  }

  next()
}
